import React, { useEffect } from "react";
import { connect } from "react-redux";
import { RootState } from "src/ipm-shared/store/model/reducers";
import { history } from "src/ipm-shared/store";

import * as selectors from "src/bepaid/store/model/Fetch/selectors";
import FeatureGateUtil from "src/ipm-shared/components/FeatureGating/Util";
import ROUTES from "../routes";

const mapStateToProps = (state: RootState) => ({
  features: selectors.getFeatures(),
  isBusinessAccount: selectors.getIsBusinessAccount(state)
});

interface Options {
  businessOnly?: boolean;
}

const withBlockOnPendingReview = (
  WrapperComponent: React.ComponentType,
  options: Options = {}
) => {
  const HOC = (props: any) => {
    const isNormalPaymentBlocked = !FeatureGateUtil.verifyFeature(
      props.features,
      "NORMAL_PAYMENT"
    );
    const shouldBlock = options.businessOnly
      ? isNormalPaymentBlocked && props.isBusinessAccount
      : isNormalPaymentBlocked;

    useEffect(() => {
      if (shouldBlock) {
        history.push(ROUTES.ROOT);
      }
    }, [shouldBlock]);

    if (shouldBlock) {
      return null;
    }

    return <WrapperComponent {...props} />;
  };

  return connect(mapStateToProps)(HOC);
};

export default withBlockOnPendingReview;
